// extracted by mini-css-extract-plugin
export default {"container":"PersonnelListItem_container__jLvKW","name":"PersonnelListItem_name__BT2VZ","info":"PersonnelListItem_info__eA4T5"};